import { connect } from 'react-redux';
import { validateForm, loadPage, layoutUpdate } from 'src/actions/common';
import GetOrderStatusPage from './GetOrderStatusPage';
import { submitForm } from './actions';
import { PAGE_NAME } from './constants';

function mapstateToProps(state) {
  return {
    pageErrors: state.getIn(['pages', PAGE_NAME, 'errors'], {}).toJS(),
  };
}

export default connect(mapstateToProps, { submitForm, loadPage, layoutUpdate, validateForm })(
  GetOrderStatusPage,
);
